import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useLabelFromGroups } from '../../shared/hooks/use-label-from-groups';
import GpanelContactsSyncForm from './gpanel-contacts-sync-form';
import { createSync, GPanelContactsKeys } from '../../gpanel-contacts-api';
import { LabelSync } from '../../shared/types';
import { useState } from 'react';

export default function GpanelContactsNewSync() {
  const label = useLabelFromGroups();
  const queryClient = useQueryClient();
  const [newLabelId, setNewLabelId] = useState<number | undefined>(undefined);

  const mutation = useMutation({
    mutationFn: ({
      sync,
      changeLogMessage,
    }: {
      sync: Partial<LabelSync>;
      changeLogMessage?: string;
    }) => createSync(sync, changeLogMessage),

    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [GPanelContactsKeys.AllSyncs],
      });
      queryClient.invalidateQueries({
        queryKey: [GPanelContactsKeys.LabelGroups],
      });

      if (label?.id) {
        queryClient.invalidateQueries({
          queryKey: [
            GPanelContactsKeys.LabelSyncs,
            String(newLabelId ? newLabelId : label.id),
          ],
        });
        queryClient.invalidateQueries({
          queryKey: [
            GPanelContactsKeys.GPanelLabels,
            String(newLabelId ? newLabelId : label.id),
          ],
        });
      }
    },
  });

  return (
    <GpanelContactsSyncForm
      title="Create Contact Sync"
      submitText="Start Sync"
      setNewLabel={setNewLabelId}
      caption={
        "Sync contacts from the Source Label to Google Contacts. This is a one-way sync. We'll start the process immediately and automatically update any changes you make to your contacts immediately."
      }
      mutation={mutation}
    />
  );
}
